<template>
  <div class="screen-container" style="margin: 0 auto;">
    <div class="demo" :data-noscroll="overlayPanel?true:false" :data-guided="guidedMode" :data-show-links="showLinks">

      <div class="screens" ref="screens">

        <!-- DASHBOARD -->

        <div class="screen z-max" data-screen="admin-i9" :data-active="currentScreen=='admin-i9'">
          <img class="w-full max-w-100" src="/img/screens/hiretech/hiretech-i9-employee-info.png?v=01192023" />
          <div class="links">
            <screen-link left="0%" top="0%" width="21%" height="6.5%" data-tgt-scrolltop="true" dot-class="dot-right-center" data-tgt="" @click.native="closeAdminTab"></screen-link>
            <screen-link left="83.5%" top="83%" width="7.5%" height="6%" data-tgt-scrolltop="true" dot-class="dot-top-center" data-tgt="admin-i9-docs" @click.native="onLinkClick"></screen-link>
          </div>
        </div>

        <div class="screen z-max" data-screen="admin-i9-docs" :data-active="currentScreen=='admin-i9-docs'">
          <img class="w-full max-w-100" src="/img/screens/hiretech/hiretech-i9-employee-info-verification.png?v=01192023" />
          <div class="links">
            <screen-link left="0%" top="0%" width="21%" height="6.5%" data-tgt-scrolltop="true" dot-class="dot-right-center" data-tgt="" @click.native="closeAdminTab"></screen-link>
            <screen-link left="11%" top="71.5%" width="24%" height="6%" data-tgt-scrolltop="true" dot-class="dot-left-center" data-tgt="admin-i9-passport" @click.native="onLinkClick"></screen-link>
          </div>
        </div>

        <div class="screen z-max" data-screen="admin-i9-passport" :data-active="currentScreen=='admin-i9-passport'">
          <img class="w-full max-w-100" src="/img/screens/hiretech/hiretech-i9-employee-info-passport.png?v=01192023" />
          <div class="links">
            <screen-link left="0%" top="0%" width="21%" height="6.5%" data-tgt-scrolltop="true" dot-class="dot-right-center" data-tgt="" @click.native="closeAdminTab"></screen-link>
            <screen-link left="83.5%" top="160%" width="7%" height="6%" data-tgt-scrolltop="true" dot-class="dot-left-center" data-tgt="admin-i9-passport-upload" @click.native="onLinkClick"></screen-link>
          </div>
        </div>

        <div class="screen z-max" data-screen="admin-i9-passport-upload" :data-active="currentScreen=='admin-i9-passport-upload'">
          <img class="w-full max-w-100" src="/img/screens/hiretech/hiretech-i9-employee-info-passport-upload.png?v=01192023" />
          <div class="links">
            <screen-link left="0%" top="0%" width="21%" height="6.5%" data-tgt-scrolltop="true" dot-class="dot-right-center" data-tgt="" @click.native="closeAdminTab"></screen-link>
            <screen-link left="11%" top="57%" width="78%" height="13%" dot-class="dot-bottom-center"  data-tgt="admin-i9-passport-uploaded" @click.native="onLinkClick"></screen-link>
          </div>
        </div>

        <div class="screen z-max" data-screen="admin-i9-passport-uploaded" :data-active="currentScreen=='admin-i9-passport-uploaded'">
          <img class="w-full max-w-100" src="/img/screens/hiretech/hiretech-i9-employee-info-passport-uploaded.png?v=01192023" />
          <div class="links">
            <screen-link left="0%" top="0%" width="21%" height="6.5%" data-tgt-scrolltop="true" dot-class="dot-right-center" data-tgt="" @click.native="closeAdminTab"></screen-link>
            <screen-link left="83.5%" top="99.5%" width="7%" height="6%" dot-class="dot-left-center"  data-tgt-scrolltop="true" data-tgt="admin-i9-confirm" @click.native="onLinkClick"></screen-link>
          </div>
        </div>

        <div class="screen z-max" data-screen="admin-i9-confirm" :data-active="currentScreen=='admin-i9-confirm'">
          <img class="w-full max-w-100" src="/img/screens/hiretech/hiretech-i9-confirm.png?v=01192023" />
          <div class="links">
            <screen-link left="0%" top="0%" width="21%" height="6.5%" data-tgt-scrolltop="true" dot-class="dot-right-center" data-tgt="" @click.native="closeAdminTab"></screen-link>
            <screen-link left="21%" top="100.5%" width="34%" height="6%" dot-class="dot-left-center" data-tgt="admin-i9-confirm-signature" @click.native="onLinkClick"></screen-link>
          </div>
        </div>

        <div class="screen z-max" data-screen="admin-i9-confirm-signature" :data-active="currentScreen=='admin-i9-confirm-signature'">
          <img class="w-full max-w-100" src="/img/screens/hiretech/hiretech-i9-confirm-signature.png?v=01192023" />
          <div class="links">
            <screen-link left="0%" top="0%" width="21%" height="6.5%" data-tgt-scrolltop="true" dot-class="dot-right-center" data-tgt="" @click.native="closeAdminTab"></screen-link>
            <screen-link left="79.5%" top="120.25%" width="11%" height="6%" data-tgt-scrolltop="true" dot-class="dot-left-center" data-tgt="admin-i9-complete" @click.native="onLinkClick"></screen-link>
          </div>
        </div>

        <div class="screen z-max" data-screen="admin-i9-complete" :data-active="currentScreen=='admin-i9-complete'">
          <img class="w-full max-w-100" src="/img/screens/hiretech/hiretech-i9-complete.png?v=01192023" />
          <div class="links">
            <screen-link left="0%" top="0%" width="21%" height="6.5%" data-tgt-scrolltop="true" dot-class="dot-right-center" data-tgt="" @click.native="closeAdminTab"></screen-link>
            <screen-link left="30%" top="10%" width="40%" height="25%" data-tgt-scrolltop="true" dot-class="dot-bottom-center" data-tgt="admin-i9-completed" @click.native="closeAdminTab"></screen-link>
          </div>
        </div>


        <div class="screen z-max" data-screen="i9" :data-active="currentScreen=='i9'">
          <img class="w-full max-w-100" src="/img/screens/hiretech/employee-tasks-pay-i9-hire-info.png?v=01192023" />
          <div class="links">
            <screen-link left="0%" top="1%" width="19%" height="6%" data-tgt-scrolltop="true" dot-class="dot-right-center" data-tgt="" @click.native="closeTab"></screen-link>
            <screen-link left="67%" top="97%" width="7.5%" height="6%" data-tgt-scrolltop="true" dot-class="dot-top-center" data-tgt="i9-citizenship" @click.native="onLinkClick"></screen-link>
          </div>
        </div>

        <div class="screen z-max" data-screen="i9-citizenship" :data-active="currentScreen=='i9-citizenship'">
          <img class="w-full max-w-100" src="/img/screens/hiretech/employee-tasks-pay-i9-citizenship-checked.png?v=01192023" />
          <div class="links">
            <screen-link left="0%" top="1%" width="19%" height="6%" data-tgt-scrolltop="true" dot-class="dot-right-center" data-tgt="" @click.native="closeTab"></screen-link>
            <screen-link left="24%" top="65.5%" width="7.5%" height="6%" data-tgt-scrolltop="true" dot-class="dot-top-center" data-tgt="i9" @click.native="onLinkClick"></screen-link>
            <screen-link left="67%" top="65.5%" width="7.5%" height="6%" data-tgt-scrolltop="true" dot-class="dot-top-center" data-tgt="i9-translator" @click.native="onLinkClick"></screen-link>
          </div>
        </div>

        <div class="screen z-max" data-screen="i9-translator" :data-active="currentScreen=='i9-translator'">
          <img class="w-full max-w-100" src="/img/screens/hiretech/employee-tasks-pay-i9-translator-checked.png?v=01192023" />
          <div class="links">
            <screen-link left="0%" top="1%" width="19%" height="6%" data-tgt-scrolltop="true" dot-class="dot-right-center" data-tgt="" @click.native="closeTab"></screen-link>
            <screen-link left="25%" top="53.5%" width="7.5%" height="6%" data-tgt-scrolltop="true" dot-class="dot-top-center" data-tgt="i9-citizenship" @click.native="onLinkClick"></screen-link>
            <screen-link left="68%" top="53.5%" width="7.5%" height="6%" data-tgt-scrolltop="true" dot-class="dot-top-center" data-tgt="i9-review" @click.native="onLinkClick"></screen-link>
          </div>
        </div>

        <div class="screen z-max" data-screen="i9-review" :data-active="currentScreen=='i9-review'">
          <img class="w-full max-w-100" src="/img/screens/hiretech/employee-tasks-pay-i9-employee-info.png?v=01192023" />
          <div class="links">
            <screen-link left="0%" top="1%" width="19%" height="6%" data-tgt-scrolltop="true" dot-class="dot-right-center" data-tgt="" @click.native="closeTab"></screen-link>
            <screen-link left="24%" top="61%" width="7.5%" height="6%" data-tgt-scrolltop="true" dot-class="dot-top-center" data-tgt="i9-translator" @click.native="onLinkClick"></screen-link>
            <screen-link left="67%" top="61%" width="7.5%" height="6%" data-tgt-scrolltop="true" dot-class="dot-top-center" data-tgt="i9-signature" @click.native="onLinkClick"></screen-link>
          </div>
        </div>

        <div class="screen z-max" data-screen="i9-signature" :data-active="currentScreen=='i9-signature'">
          <img class="w-full max-w-100" src="/img/screens/hiretech/employee-tasks-pay-i9-signature.png?v=01192023" />
          <div class="links">
            <screen-link left="0%" top="1%" width="19%" height="6%" data-tgt-scrolltop="true" dot-class="dot-right-center" data-tgt="" @click.native="closeTab"></screen-link>
            <screen-link left="38.5%" top="33%" width="32%" height="5%" data-tgt-scrolltop="true" dot-class="dot-left-center" data-tgt="i9-signed" @click.native="onLinkClick"></screen-link>
            <screen-link left="24%" top="52%" width="7.5%" height="6%" data-tgt-scrolltop="true" dot-class="dot-top-center" data-tgt="i9-review" @click.native="onLinkClick"></screen-link>

          </div>
        </div>

        <div class="screen z-max" data-screen="i9-signed" :data-active="currentScreen=='i9-signed'">
          <img class="w-full max-w-100" src="/img/screens/hiretech/employee-tasks-pay-i9-signature-signed.png?v=01192023" />
          <div class="links">
            <screen-link left="0%" top="1%" width="19%" height="6%" data-tgt-scrolltop="true" dot-class="dot-right-center" data-tgt="" @click.native="closeTab"></screen-link>
            <screen-link left="38.5%" top="33%" width="32%" height="5%" data-tgt-scrolltop="true" dot-class="dot-left-center" data-tgt="i9-signed" @click.native="onLinkClick"></screen-link>
            <screen-link left="24%" top="52%" width="7.5%" height="6%" data-tgt-scrolltop="true" dot-class="dot-top-center" data-tgt="i9-review" @click.native="onLinkClick"></screen-link>
            <screen-link left="67%" top="52%" width="7.5%" height="6%" data-tgt-scrolltop="true" dot-class="dot-top-center" data-tgt="i9-submit" @click.native="onLinkClick"></screen-link>
          </div>
        </div>

        <div class="screen z-max" data-screen="i9-submit" :data-active="currentScreen=='i9-submit'">
          <img class="w-full max-w-100" src="/img/screens/hiretech/employee-tasks-pay-i9-submit.png?v=01192023" />
          <div class="links">
            <screen-link left="0%" top="1%" width="19%" height="6%" data-tgt-scrolltop="true" dot-class="dot-right-center" data-tgt="" @click.native="closeTab"></screen-link>

            <screen-link left="56%" top="22.5%" width="11%" height="6%" data-tgt-scrolltop="true" dot-class="dot-top-center" data-tgt="i9-review" @click.native="onLinkClick"></screen-link>
            <screen-link left="43%" top="22.5%" width="12%" height="6%" data-tgt-scrolltop="true" dot-class="dot-top-center" data-tgt="i9-confirm" @click.native="onLinkClick"></screen-link>
          </div>
        </div>

        <div class="screen z-max" data-screen="i9-confirm" :data-active="currentScreen=='i9-confirm'">
          <img class="w-full max-w-100" src="/img/screens/hiretech/employee-tasks-pay-i9-confirmation.png?v=01192023" />
          <div class="links">
            <screen-link left="0%" top="1%" width="19%" height="6%" data-tgt-scrolltop="true" dot-class="dot-right-center" data-tgt="" @click.native="closeTab"></screen-link>

            <screen-link left="66.5%" top="75.5%" width="7.5%" height="6%" data-tgt-scrolltop="true" dot-class="dot-top-center" data-tgt="i9-completed" @click.native="onLinkClick"></screen-link>
          </div>
        </div>

        <div class="screen z-max" data-screen="i9-completed" :data-active="currentScreen=='i9-completed'">
          <img class="w-full max-w-100" src="/img/screens/hiretech/employee-tasks-pay-i9-completed.png?v=01192023" />
          <div class="links">
            <screen-link left="0%" top="1%" width="19%" height="6%" data-tgt-scrolltop="true" dot-class="dot-right-center" data-tgt="" @click.native="closeTab"></screen-link>

            <screen-link left="29%" top="15%" width="42%" height="28%" data-tgt-scrolltop="true" dot-class="dot-bottom-center" data-tgt="i9-completed" @click.native="closeTab"></screen-link>
          </div>
        </div>




    </div>
      <demo-menu v-if="showMenu"></demo-menu>
    </div>

  </div>

</template>

<script>
import ScreenLink from "../components/ScreenLink";
//import FlexNavTopBar from "../components/FlexNavTopBar";
//import FlexSideNav from "../components/FlexAdminSideNav";
//import InfoBox from "../components/InfoBox";
import DemoMenu from "@/components/DemoMenu";
// import PeoplePullout from "@/components/PeoplePullout";
// import SelectBox from "@/components/SelectBox";
// import NewsPullout from "@/components/NewsPullout";
// import NotificationsPullout from "@/components/NotificationsPullout";

// import FiltersPanel from "../components/FiltersPanel";
// import SelectBox from "@/components/SelectBox";
// import FlexInfo from "@/components/FlexInfo";

export default {
  name: "hiretech-screens",
  components: { ScreenLink, DemoMenu /*FiltersPanel, FlexInfo, SelectBox,*/ },
  mounted: function(){

    // this.$store.commit("showMenu", false);
    // if(this.$route.query){
    //   if(this.$route.query.guided){
    //
    //     let value = (this.$route.query.guided.trim() === "true");
    //     console.log("guided param",this.$route.query.guided, value )
    //     this.$store.commit("guidedMode", value);
    //   }else{
    //     this.$store.commit("guidedMode", false);
    //   }
    //
    //   if(this.$route.query.comments){
    //     this.$store.commit("showFeedback", true);
    //   }
    // }

  },
  props: {},
  data: function () {
    return {
      defaultScreen: 'hr-training',
      visibility: {
        topnav: true
      },
      overlayPanel: null,
      pulloutPanel: null,
      disableScreenScoll: false,
      salesAdded: false

    }
  },
  methods: {

    closeTab: function(){
        this.onLinkClick({
          target: {
            dataset: {
              tgtMode: "employee",
              tgt: "dashboard-tasks"
            }
          }
        })
    },

    closeAdminTab: function(){
      this.onLinkClick({
        target: {
          dataset: {
            tgtMode: "admin",
            tgt: "dashboard-all-tasks"
          }
        }
      })
    },

    onSetGuided: function(guided){

      //this.guidedMode = guided;
      //this.showMenu = false;

      this.$store.commit("guidedMode", guided);
      this.$store.commit("showMenu", false);

    },

    showPrevious: function(){
      this.$router.back();
    },

    onLinkClick: function(e){
      // this.currentScreen = e.target.dataset.tgt;



      if(e.target.dataset.commit){
        this.$store.commit(e.target.dataset.commit, e.target.dataset.commitValue);
      }

      if(!e.target.dataset.tgt && this.pulloutPanel) {
        this.pulloutPanel = null;
      }else if(e.target.dataset.isOverlay){
        this.overlayPanel = e.target.dataset.tgt
      }else{
        console.log("scroll top", e.target.dataset.tgtScrolltop)
        this.setScreen(e.target.dataset.tgt, e.target.dataset.tgtMode,  e.target.dataset.tgtScrolltop);
      }


    },

    showExternalPage: function(e){
      // this.currentScreen = e.target.dataset.tgt;
      let tgtUrl = e.target.dataset.tgt;
      window.open(tgtUrl, "_blank");
    },

    showPullout: function(e){
      // this.currentScreen = e.target.dataset.tgt;
      this.pulloutPanel = e.target.dataset.tgt
    },

    onSelectClick: function(tgt){
      // this.currentScreen = e.target.dataset.tgt;

      this.setScreen(tgt);



    },

    setScreen: function(id, mode, scrollToTop){
      this.overlayPanel = null;
      this.pulloutPanel = null;
      console.log(id);

      if(!mode){
        mode = "hiretech"
      }

      if(id == this.$route.params.screen){
        //this.$router.go(0);
      }else{
        this.$router.push({name: mode, params: { screen: id}});
        if(scrollToTop){
          console.log("scrolling", this.$refs)
          //this.$refs['screens'].scrollTo(0,0);
          window.scrollTo(0,0);
        }
      }

    },


    onSideNavLink: function(link){
      if(link){
        let linkParams = link.split(":");
        if(linkParams[0] == "hr"){

          this.$router.push({name: "training", params: { screen: linkParams[1]}});

        }
      }

    },

    onTopNavLink: function(link){


      if(link){
        let linkParams = link.split(":");
        if(linkParams[0] == "pullout"){
          this.showOverlay(linkParams[1]);

        }
      }

    },

    showOverlay: function(id){
      this.overlayPanel = id;
    }
  },
  computed: {

    showMenu: function(){
      return this.$store.state.showMenu;
    },

    showLinks: function(){
      return this.$store.state.showLinks;
    },

    guidedMode: function(){
      return this.$store.state.guidedMode;
    },

    currentScreen: function(){

      let target = this.defaultScreen;
      if(this.$route.params.screen){
        target = this.$route.params.screen;
      }

      return target
    },

    sideNavLink: function(){
      if(this.$route.params.screen){
        return this.$route.params.screen.split("-")[0];
      }else{
        return "dashboard";
      }
    },

    sideNavMode: function(){
      if(this.$route.query.mode){
        return this.$route.query.mode;
      }else{
        return "admin";
      }
    }
  }
}
</script>

<style scoped>

img {
  margin: 0;
}




.demo {
  width: 100%;
  position: relative;



}

.demo[data-noscroll="true"]{


}



.screens {

  position: relative;
  width: 100%;
  overflow-x: hidden;
}

.overlay {
  position: absolute;
  width: calc((320/1580) * 100%);
  top: calc((60/920) * 100%);
  right: 0;
  display: none;
}

.overlay[data-active="true"] {
  display: block;
}

.pullout {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  display: none;
  background-color: rgba(0,0,0,0.49);
}

.pullout[data-active="true"] {
  display: block;
}

.popover {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  display: none;
}

.popover[data-active="true"] {
  display: block;
}

.overlay[data-active="true"] {
  display: block;
}

.screens .screen {
  position: relative;
  width: 100%;
  display: none;
}

.screen[data-active="true"] {
  display: block;
}

.screen .links {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 0;
  padding-top: calc((920/1580) * 100%);
}

.pullout .links {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 0;
  padding-top: calc((920/1580) * 100%);
}


/* UTILITIES */

.w-full {
  width: 100%;
}



.pullout-1200 {
  position: absolute;
  width: calc(100% * (1200 / 3160));
  top: 0;
  right: 0;
}

.popover-email {
  position: absolute;
  width: calc(100% * (1000 / 1580));
  top: 20%;
  right: 5%;
  box-shadow: 0 10px 20px rgba(0,0,0,0.3);

}

.popover-with-bkg {
  background-color: rgba(0,0,0,0.4);


}

.popover-time-attendance {
  position: absolute;
  width: calc(100% * (1000 / 1580));
  top: 20%;
  right: 15%;
  box-shadow: 0 10px 20px rgba(0,0,0,0.3);

}

.popover-schedule-details {
  position: absolute;
  width: calc(100% * (808 / 1580));
  top: 20%;
  right: 20%;
  box-shadow: 0 10px 20px rgba(0,0,0,0.3);

}

.x-ray {
  opacity: 0.5;
}

*[data-hidden] {
  opacity: 0;
}



.demo[data-show-links="true"] .select-box {

}

.demo[data-show-links="true"] .flex-info {
  border: 2px solid var(--color-green);
}

.demo[data-show-links="true"] .info-box {
  display: block;
}

.demo .info-box {
  display: none;
}


.demo[data-guided="true"] .info-box {
  display: block;
}

.z-max {
  z-index: 50;
}

.z-45 {
  z-index: 45;
}

.z-40 {
  z-index: 40;
}

.info-box {
  z-index: 30;
}

.demo-menu {
  top: 0;
}

</style>

<style>
  html {
    background: white;
  }
</style>
